import React from 'react'
import { useSelector } from 'react-redux'
import { Typography } from 'antd'
import { selectCompanyPaymentMethods } from '@reducers/currentUser/currentUserSelectors'
import MakeDefaultPaymentMethodButton from '../MakeDefaultPaymentMethodButton'
import DeletePaymentMethodButton from '../DeletePaymentMethodButton'
import styles from './PaymentMethodList.module.scss'

const { Text } = Typography

const PaymentMethodList = () => {
  const paymentMethods = useSelector(selectCompanyPaymentMethods)

  if (!paymentMethods.length) {
    return null
  }

  const disableDeleteButton = paymentMethods.length === 1

  return (
    <React.Fragment>
      <table className={styles.paymentMethodTable}>
        <tbody>
          {paymentMethods.map((paymentMethod) => {
            return (
              <tr key={paymentMethod.id}>
                <td>
                  {paymentMethod.display}
                </td>
                <td>
                  {paymentMethod.default_payment
                    ? (
                    <Text strong>Default</Text>
                      )
                    : (
                    <MakeDefaultPaymentMethodButton
                      paymentMethodId={paymentMethod.id}
                    />
                      )}
                </td>
                <td>
                  {!paymentMethod.external && (
                    <DeletePaymentMethodButton disabled={disableDeleteButton} paymentMethodId={paymentMethod.id} />
                  )}
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </React.Fragment>
  )
}

export default PaymentMethodList
